@let isTeacher = isTeacher$ | async;
@let data = data$ | async;
<div
  class="flex h-full w-full flex-col items-center justify-center gap-5 rounded-xl py-8"
  [ngClass]="{
    'bg-amber-100': isTeacher,
    'border border-dashed border-base-gray-300 bg-base-light-container': !isTeacher,
  }"
>
  @if (isTeacher) {
    <span class="text-md">
      {{ data?.activity?.completed }}/{{ data?.activity?.total }} {{ 'eclass.respostas' | translate }}
    </span>
    <button
      app-button
      (click)="onOpenReview(data)"
      class="flex-row items-center gap-2 rounded-md bg-theme-400 px-10 text-white"
    >
      <svg-icon class="w-6" src="/assets/icons/icon-view.svg"></svg-icon>
      <span class="text-md" translate>eclass.tarefa.ver-respostas</span>
    </button>
  } @else {
    @if (answerStatus(); as answer) {
      @if (isLate(answer.status)) {
        <div class="flex justify-center items-center gap-2">
          <svg-icon class="text-warning w-4 h-4" src="assets/icons/icon-alert-img.svg"></svg-icon>
          <span class="text-gray-500" translate>eclass.tarefa.prazo-encerrado</span>
        </div>
      }
      <button
        app-button
        [disabled]="isLate(answer.status)"
        (click)="onOpenAnswers(answer.status)"
        class="bg-base- flex-row items-center gap-2 rounded-md bg-theme-400 px-10 text-white"
        [ngClass]="{
          'bg-base-status-success!': isWaiting(answer.status) || isCompleted(answer.status),
        }"
      >
        <svg-icon class="w-6" [src]="iconStatus(answer.status)"></svg-icon>
        <span class="text-md">{{ answer?.label | translate }}</span>
      </button>
    }
  }
</div>
